import { useSearchParams } from 'next/navigation';
import { PRICING_URL } from '#constants';

export function useBackButton() {
  const searchParams = useSearchParams();

  const showBackButton = searchParams.get('f') === 'pricing';
  const pricingUrl = [PRICING_URL, searchParams.toString()]
    .filter(Boolean)
    .join('?');

  return {
    showBackButton,
    pricingUrl,
  };
}
